export default __webpack_public_path__ + "static/media/undelete.5a30ab49.svg";